import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from '@sib/i18n';
import { ComboboxItem, ComboboxOption } from '@sib/ui';

interface UseStaticAutocompletePropsOptions {
  options: ComboboxOption[];
}

export const useStaticAutocompleteProps = ({
  options,
}: UseStaticAutocompletePropsOptions) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState('');

  const onInputValueChange = useCallback(
    (value: string) => setFilter(value),
    []
  );

  const filteredOptions = useMemo(() => {
    if (!filter) return options;

    const lowerFilter = filter.toLowerCase();

    return options.filter(option => {
      const label =
        typeof option.label === 'string' ? option.label : String(option.label);

      return label.toLowerCase().includes(lowerFilter);
    });
  }, [options, filter]);

  return useMemo(
    () => ({
      options: filteredOptions,
      onInputValueChange,
      searchValue: filter,
      emptyMessage: t('components.autocomplete.notSelected'),
      noResultMessage: t('noResults'),
      searchPlaceholder: t('components.autocomplete.searchPlaceholder'),
      OptionComponent: ComboboxItem,
    }),
    [filteredOptions, filter, onInputValueChange, t]
  );
};
